module.exports = __webpack_public_path__ + "static/img/icon_washcard.ca34f34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_washcard.png
// module id = xgjS
// module chunks = 1